import { ClientEnd } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

/**
 * Sends add client request to create new company client
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const addClient = async (data: RequestAddClient): Promise<any> =>
    APIManager.sendPost(ClientEnd.ADD_CLIENT, data, true, {}, {}, axios);

/**
 * Sends a GET request to retrieve the client list.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getClientList = async (data: RequestedClientList): Promise<any> =>
    APIManager.sendGetWithBody(ClientEnd.GET_CLIENT_LIST, data, true, axios);
/**
 * Sends a GET request to retrieve the client list.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getClient = async (data: RequestedClient): Promise<any> =>
    APIManager.sendGet(
        `${ClientEnd.GET_CLIENT}/${data.clientId}`,
        true,
        {},
        {},
        axios
    );
/**
 * Sends a DELETE request to remove client data.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const deleteClient = async (data: RequestedClient): Promise<any> =>
    APIManager.sendDelete(
        `${ClientEnd.GET_CLIENT}/${data.clientId}`,
        true,
        {},
        {},
        axios
    );
/**
 * Sends a GET request to retrieve the spesific client list.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getEnabledClient = async (data: RequestedClientList): Promise<any> =>
    APIManager.sendGetWithBody(ClientEnd.GET_CLIENT_ENABLED, data, true, axios);

/**
 * Sends a GET request to retrieve the file for client audit.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getClientAudit = async (data: RequestedClientAudit): Promise<any> =>
    APIManager.sendGetWithBody(ClientEnd.GET_CLIENT_AUDIT, data, true, axios);

/**
 * Sends a GET request to retrieve the solicitor list.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getSolicitors = async (data: RequestedSolicitorList): Promise<any> =>
    APIManager.sendGetWithBody(ClientEnd.GET_SOLICITOR, data, true, axios);

/**
 * Sends a POST request to edit a company client.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const editClient = async (data: RequestEditClient): Promise<any> =>
    APIManager.sendPatch(ClientEnd.EDIT_CLIENT, data, true, {}, {}, axios);

/**
 * Sends a POST request to edit checklist client file
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const replaceClientChecklist = async (
    data: RequestEditChecklist
): Promise<any> =>
    APIManager.sendPost(
        ClientEnd.REPLACE_CLIENT_CHECKLIST,
        data,
        true,
        {},
        {},
        axios
    );
/**
 * Patch a client checklist to active
 * @param {RequestToggleChecklistStep} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const toggleClientChecklist = async (
    data: RequestToggleChecklistStep
): Promise<any> =>
    APIManager.sendPatch(
        ClientEnd.TOGGLE_CLIENT_CHECKLIST_STEP,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Patch a checklist review step to toggled between active and hidden
 * @param {RequestToggleChecklistStep} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const toggleHideCheck = async (
    data: RequestToggleChecklistStep
): Promise<any> =>
    APIManager.sendPatch(
        ClientEnd.REVIEW_HIDE_CHECK,
        data,
        true,
        {},
        {},
        axios
    );

export const ClientService = {
    addClient,
    getClient,
    getClientList,
    getClientAudit,
    getSolicitors,
    editClient,
    deleteClient,
    replaceClientChecklist,
    toggleClientChecklist,
    toggleHideCheck,
    getEnabledClient,
};
